<div id="custom-milestone" class="timeline-card-container" (contextmenu)="onContextMenu($event)">
  <div class="timeline-card" data-testid="card" (click)="onCardClick()">
    <!-- Icon Column -->
    <div class="card-icon">
      <svg width="100%" height="100%" viewBox="0 0 102 100">
        <g transform="translate(-278.809367612789 -1306.809367612789)">
          <path
            d="M325.1 1311.58a6 6 0 0 1 8.48 0l41.5 41.5a6 6 0 0 1 0 8.5l-41.5 41.5a6 6 0 0 1-8.5 0l-41.5-41.5a6 6 0 0 1 0-8.5z"
            stroke="#ff80df" stroke-width="6" fill="#fff"/>
        </g>
      </svg>
    </div>
    
    <!-- Content Column -->
    <div class="card-content">
      <!-- Status Tag (Always at top-right) -->
      <div class="status-container">
        @if(customMilestone.isVisible == false) {
          <span class="hidden-indicator" title="Hidden">
            <rds-icon namespace="filled" icon="visibility_off"></rds-icon>
          </span>
        }
      </div>
      
      <!-- Title (Primary element) -->
      <h3 class="card-title" data-testid="title">{{ customMilestone.title }}</h3>
      
      <!-- Flexible Tag Area (Optional) -->
      @if (customMilestone.strategicPillar || (customMilestone.audiences && customMilestone.audiences.length > 0)) {
        <div class="tags-container">
          @if (customMilestone.strategicPillars && customMilestone.strategicPillars.length > 0) {
            @for (sp of customMilestone.strategicPillars; track sp) {
              <span class="strategic-pillar-tag" 
                    [style.background-color]="sp.color_code"
        [style.color]="getContrastColor(sp.color_code)"
                    [title]="'Strategic Pillar: ' + sp.title">
                {{ sp.title }}
              </span>
            }
          }
            @if (customMilestone.audiences && customMilestone.audiences.length > 0) {
              @for (aud of customMilestone.audiences; track aud) {
                <span class="veeva-audience-tag"
                    [title]="'Audience: ' + aud.name">
                {{ aud.name }}
              </span>
              }
            }
        </div>
      }
      
      <!-- Keywords -->
      <div class="keywords-container">
        @for (keyword of customMilestone.keyWords; track keyword) {
          <span class="keyword-tag" data-testclass="keyword">{{ keyword }}</span>
        }
      </div>
    </div>
  </div>
</div>
